import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'hb-auth-input',
  templateUrl: './auth-input.component.html',
  styleUrls: ['./auth-input.component.scss'],
})
export class AuthInputComponent {
  @Input() name: string = '';
  @Input() type: string = '';
  @Input() placeholder: string = '';
  @Input() showError: boolean = false;
  @Input() control: FormControl = new FormControl();
  @Input() icon: string = '';

  constructor() {}
}
